
import Backbone from 'backbone'
import Cocktail from 'backbone.cocktail'
import FacadeMixin from './mixins/FacadeMixin'
import HitArea from '../facades/HitArea'
import MapModelMixin from './mixins/MapModelMixin'
import TagsMixin from './mixins/TagsMixin'

class HitAreaModel extends Backbone.Model {

  defaults() {
    return {
      fill: 'rgba(0,0,0,0)'
    }
  }

  initialize(attributes, options) {
    this._facade = new HitArea(this)
  }

  target() {
    var target = this.get('target')
    if (!target) {
      return null
    }

    switch (target.type) {
      case 'Unit':
        let units = this.mapModel().get('units')
        return units.get(target.id)
      default:
        return null
    }
  }

  color(value) {
    this.set('fill', value)
    return this
  }

  stroke(color, width = 1) {
    this.set({stroke: color, strokeWidth: width})
    return this
  }

  data() {
    return this.toJSON()
  }
}

Cocktail.mixin(HitAreaModel, MapModelMixin, FacadeMixin, TagsMixin)

export default HitAreaModel
